import useSelectionState from "../../../pages/agent/selection-state";
import { DashboardTicketState, useAddTicketStateIdMutation } from "../../../__generated__/api";

export default function SetTicketState(): null {
    const selectionState = useSelectionState();
    const [addState] = useAddTicketStateIdMutation();

    const setState = async (ids: string[], state: DashboardTicketState): Promise<void> => {
        await addState({
            variables: {
                chatIds: ids,
                stateId: state.ticketStateId,
            },
        });
    };

    selectionState.registerSetChatStateHandler(setState);

    return null;
}
